import React from 'react'
import { ChevronsRight } from 'lucide-react'

import type { Cta1Block as Cta1BlockProps } from '@/payload-types'
import type { Media as MediaType } from '@/payload-types'

import RichText from '@/components/RichText'
import { Media } from '@/components/Media'
import { CMSLink } from '@/components/Link'
import { Card } from '@/components/ui/card'

export const Cta1Block: React.FC<
  Cta1BlockProps & {
    id?: string
    blockName?: string
    blockType: 'cta1'
  }
> = ({ title, description, links, image }) => {
  return (
    <section>
      <div className="container">
        <Card className="flex flex-col justify-between border-muted pb-0 md:flex-row md:py-6">
          <div className="p-6 md:max-w-96">
            <div className="mb-2 flex items-center gap-2">
              {title && (
                <div className="text-2xl font-bold">
                  <RichText data={title} enableGutter={false} enableProse={false} />
                </div>
              )}
            </div>
            {description && (
              <div className="text-muted-foreground">
                <RichText data={description} enableGutter={false} enableProse={false} />
              </div>
            )}
            {links && links.length > 0 && (
              <div className="mt-8">
                {links.map((item: any, i: number) => (
                  <div key={i} className="relative overflow-hidden group rounded-full inline-flex">
                    <CMSLink
                      {...item.link}
                      className="z-10 inline-flex items-center border border-primary text-primary-foreground bg-primary hover:bg-primary/90 cursor-pointer font-semibold text-base tracking-wide transition-colors duration-300 rounded-full px-6 py-3"
                      aria-label={item.link.label || 'Get Started'}
                    >
                      {item.link.label || 'Get Started'}
                      <div className="w-8 h-8 rounded-full flex items-center justify-center ml-2 bg-primary text-primary-foreground">
                        <ChevronsRight className="size-4" />
                      </div>
                    </CMSLink>
                  </div>
                ))}
              </div>
            )}
          </div>
          {image && (
            <Media
              resource={image as MediaType}
              imgClassName="h-full w-full object-cover object-contain md:max-w-96"
              alt={typeof image === 'object' && image?.alt ? image.alt : 'CTA image'}
            />
          )}
        </Card>
      </div>
    </section>
  )
}
